import React, { Component } from 'react';
import { CardLayout, BreadCrumb } from './containers/Layout';
import { isEmpty } from "lodash";
import Spin from '../../../commonModules/interface/Spin';

import Form from './comRea/Form';
import ListComRea from './comRea/ListComRea';
import SingleComRea from './comRea/SingleComRea';
import SingleShop from './shops/SingleShop';

import FormReturn from './comReturn/Form';
import ListComReturn from './comReturn/ListComReturn';
import SingleComReturn from './comReturn/SingleComReturn';
import CommercialPopUp from '../../AdminDashboard/Agents/CommercialPopUp';
import { Button, Card, Grid, Box } from '@material-ui/core';
import SwipeableTabs from '../../../commonModules/MUI/SwipeableTabs';
import CardPage from '../../../commonModules/layouts/CardPage';
import ListTransferCommercials from './transfers/commercials/ListTransferCommercials';
import SingleTransferCommercial from './transfers/commercials/SingleTransferCommercial';
import ListTransferCommercialReturns from './transfers/commercials/ListTransferCommercialReturns';

class StockCommercials extends Component {
    state = { 
        breadcrumb: "",
        view: "list",
        singleRea: {
            rea:{},
            shop:{},
            client:{},
        },
        singleReturn: {
            rea:{},
            shop:{},
            client:{},
        },
        singleShop: {},
        singleCom: false,
        com: "",

        pageOfItems:[],
        pageOfItemsReturn:[],
        currentPage: 0,
        currentPageReturn: 0,
        rowsPerPage: 20,
    }
    componentDidMount = () => {
        if( isEmpty(this.props.AGENTS) ){
            this.props.fetchAgents()
        }
        // if( isEmpty(this.props.COMMERCIAL_STOCKS) ){
        //     this.props.fetchCommercialStocks()
        // }
        // if( isEmpty(this.props.COMMERCIAL_REAS) ){
        //     this.props.fetchCommercialReas()
        // }
        // if( isEmpty(this.props.COMMERCIAL_RETURNS)){
        //     this.props.fetchCommercialReturns()  
        // }
    }
    
    handleClose = () => {
        this.setState({ 
            breadcrumb: "",
            view: "list",
        })
    }
    handleSingleComRea = (rea, shop, commercial) => {
        this.setState({
            view:"rea",
            breadcrumb:`rea commercial n°${rea.id}`,
            singleRea:{rea, shop, commercial},
        })
    }
    handleSingleComReturn = (rea, shop, commercial) => {
        this.setState({
            view:"returnSingle",
            breadcrumb:`retour commercial n°${rea.id}`,
            singleReturn:{rea, shop, commercial},
        })
    }
    handleSingleShop = (shop) => {
        this.setState({
            breadcrumb: shop.name,
            singleShop:shop,
            view: "shop"
        })
    }
    handleSingleCom = (commercialID) => {
        console.log('====================================');
        console.log("handleSingleCOm", commercialID);
        console.log('====================================');
        this.setState({
            singleCom: true,
            com: commercialID
        })
    }

    onChangePageRea = (pageOfItems, page, rowsPerPage) => {
        this.setState({ pageOfItems, currentPage:page, rowsPerPage });
    }
    onChangePageReturn = (pageOfItemsReturn, page, rowsPerPage) => {
        this.setState({ pageOfItemsReturn, currentPageReturn:page, rowsPerPage });
    }
  
    render() {
        const { view, singleCom, com } = this.state;
        const { COMMERCIAL_REAS, COMMERCIAL_RETURNS, AGENTS } = this.props;

        console.log('===============STATE=====================');
        console.log(this.state);
        console.log('====================================');
        return (
            <CardPage 
                title="Stock Commercial"
                storehouse
                action={(view === "list" || view === "listReturn") &&
                <Box>
                    <Box p={1}>
                        <Button 
                            color="primary" variant="contained"
                            onClick={ () => this.setState({
                                view: "new", 
                                breadcrumb:"Nouveau Reappro"
                            })}
                        >
                            Nouveau Reappro
                        </Button>
                    </Box>
                            
                    <Box p={1}>
                        <Button 
                            color="secondary"
                            variant="contained"
                            onClick={ () => this.setState({
                                view: "newReturn", 
                                breadcrumb:"Nouveau Retour"
                            })}
                        >
                            Nouveau Retour
                        </Button>
                    </Box>

                </Box>
                }
            >
                <BreadCrumb breadcrumb={ this.state.breadcrumb } title="Stock Commercial" back={this.handleClose} />
                {/* {this.props.STATE.commercialReas.fetching && <Spin noOverlay />} */}

                {view === "new" &&
                    <Form {...this.props} handleClose={ this.handleClose } />
                }
                {view === "newReturn" &&
                    <FormReturn {...this.props} handleClose={ this.handleClose } />
                }
                {view === "rea" &&
                    <SingleTransferCommercial
                        transfer={this.state.singleRea.rea} 
                        shop={this.state.singleRea.shop} 
                        commercial={this.state.singleRea.commercial} 
                        {...this.props} 
                        getPhoto={this.props.getPhoto} 
                    />
                }
                {view === "returnSingle" &&
                    <SingleTransferCommercial
                    // <SingleComReturn
                        transfer={this.state.singleReturn.rea} 
                        shop={this.state.singleReturn.shop} 
                        commercial={this.state.singleReturn.commercial} 
                        {...this.props} 
                        getPhoto={this.props.getPhoto} 
                    />
                }
                {view === "shop" &&
                    <SingleShop shop={this.state.singleShop} {...this.props} />
                }  
                
                {( singleCom && com ) &&
                    <CommercialPopUp
                        closePopUp={ () => this.setState({
                            singleCom: false,
                            com: ""
                        })} 
                        commercial={AGENTS[com]}
                        STOCK_INFO_LIST
                        updateAgent={this.props.updateAgent}
                        {...this.props}
                    />
                }

                {(view === "list" || view === "listReturn") &&
                    <Box>
                        <SwipeableTabs
                            labels={["Sorties", "Retours"]}
                            default="Sorties"
                        >
                            <Box>
                                {/* {!isEmpty( COMMERCIAL_REAS ) &&
                                    <ListComRea */}
                                    <ListTransferCommercials
                                        {...this.props}
                                        {...this.state}
                                        onChangePage={this.onChangePageRea}
                                        handleSingleCom={this.handleSingleCom}  
                                        handleSingleShop={this.handleSingleShop}  
                                        handleSingleComRea={this.handleSingleComRea}  
                                    />
                                {/* } */}
                            </Box>

                            <Box>
                                {/* {!isEmpty( COMMERCIAL_RETURNS ) && */}
                                    {/* // <ListComReturn */}
                                    <ListTransferCommercialReturns
                                        {...this.props}
                                        {...this.state}
                                        onChangePage={this.onChangePageReturn}
                                        handleSingleCom={this.handleSingleCom}  
                                        handleSingleShop={this.handleSingleShop}  
                                        handleSingleComReturn={this.handleSingleComReturn}  
                                    />
                                {/* } */}
                            </Box>
                        </SwipeableTabs>
                            
                    </Box>
                }
            </CardPage> 
        );
    }
}

export default StockCommercials;